import React from "react";
import "./Why_Choose_Us.css";
import { IDS } from "../../../utils/common";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { getwhychooseus } from "../../../utils/apis/common/Common";

function Why_Choose_Us() {
  const cards = [
    {
      img: "/assets/images/home/why-choose-us/img/img1.jpg",
      title: "Theme-Based Event Design",
      text:
        "Creative and personalized event concepts designed to match your vision, style, and occasion perfectly.",
    },
    {
      img: "/assets/images/home/why-choose-us/img/img2.jpg",
      title: "Experienced Event Planners",
      text:
        "Our skilled team ensures smooth coordination with years of experience in managing successful events.",
    },
    {
      img: "/assets/images/home/why-choose-us/img/img3.jpg",
      title: "Premium Decor & Setup",
      text:
        "We use high-quality materials, stunning decor, and modern setups to create visually impressive events.",
    },
    {
      img: "/assets/images/home/why-choose-us/img/img4.jpg",
      title: "End-to-End Event Management",
      text:
        "Complete support from consultation to installation and maintenance.",
    },
    {
      img: "/assets/images/home/why-choose-us/img/img5.jpg",
      title: "Maximum Savings Guaranteed",
      text:
        "From planning and vendor management to execution and wrap-up — we handle everything seamlessly.",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [whychooseus, setWhyChooseUs] = useState([]);

  const getWhyChoose = async () => {
    const res = await getwhychooseus();
    if (res?.success) {
      setWhyChooseUs(res.data);
    }
  };
  useEffect(() => {
    getWhyChoose();
  }, []);

  return (
    <section className="why_choose_us py-5">
      <div className="container text-center">
        <h2 className="head_text mb-3 mt-4">
          Why Choose Us for Your Event Management
        </h2>

        <p className="text mb-5">
          We bring creativity, precision, and end-to-end planning to make your
          events seamless, memorable, and truly exceptional.
        </p>

        <div className="row g-4 justify-content-center">
          {whychooseus.map((card, index) => (
            <div
              key={index}
              className="col-12 col-lg-2 col-md-6 col-sm-6  custom_col"
            >
              <div className="why_card h-100 p-4 text-start">
                <div className="icon mb-3">
                  <img
                    src={IDS?.IMG_URL + card?.image}
               
                    alt={card.name}
                    className="why_icon_img"
                  />
                </div>
                <h5>{card.name}</h5>
                <p>{htmlToReactParser.parse(card.description)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Why_Choose_Us;
